import { useMediaQuery } from "@mui/material";

const useIsMobile = () => {
  return useMediaQuery("(max-width: 767px)");
};

export default useIsMobile;
